import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';

function getExtension(url) {
  return (url.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
}

function isUUID(str) {
  return str.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$') ? true : false;
}

function getUrlTitle(segments) {
  var title = '';
  for (let index = 0; index < segments.length; index++) {
    if (isNaN(segments[index]) && isUUID(segments[index]) === false) {
      title += (index === 0 ? '' : ' - ') + segments[index];
    }
  }
  return title;
}

function initAppInsights(envUrl) {
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: '#{instrumentationKey}#',
      disableInstrumentaionKeyValidation: true,
      disableFetchTracking: false,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      distributedTracingMode: DistributedTracingModes.W3C,
      endpointUrl: envUrl + '/appinsights/events'
    }
  });
  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer(telemetryItem => {
    let cloudRoleName = 'Unknown';
    let cloudRoleInstance = 'Unknown';
    const target = telemetryItem.baseData.target;

    if (target && isNeedFilterTelemetryItem(target, ['bam.nr-data.net', 'sessionkeepalive.aspx'])) {
      return false;
    }
    switch (telemetryItem.baseType) {
      case 'RemoteDependencyData':
        const requestHeaders = telemetryItem?.baseData?.properties?.requestHeaders;
        if (requestHeaders['ai-cloud-role']) {
          cloudRoleName = requestHeaders['ai-cloud-role'];
          if (getExtension(telemetryItem.baseData.target) === 'json') {
            telemetryItem.baseData.target =
              'http://resources-' + (cloudRoleName.split('/')[1] ? cloudRoleName.split('/')[1] : cloudRoleName);
          }
        }
        if (requestHeaders['ai-cloud-role-instance']) {
          cloudRoleInstance = requestHeaders['ai-cloud-role-instance'];
        }
        break;
      case 'ExceptionData':
        const appName = telemetryItem?.baseData?.properties?.appName;
        if (appName) {
          cloudRoleName = appName;
        }
        break;
      case 'PageviewData':
      case 'PageviewPerformanceData':
        let operationName = '';
        document.location.pathname.split('/').forEach(function(segment) {
          if (isNaN(segment)) {
            operationName += '/' + segment;
          }
        });

        telemetryItem.tags['ai.operation.name'] = operationName;
        cloudRoleName = 'RootUI';
        break;

      default:
        break;
    }

    telemetryItem.tags['ai.cloud.role'] = cloudRoleName;
    telemetryItem.tags['ai.cloud.roleInstance'] = cloudRoleInstance;
  });

  window.addEventListener('ai-trackmodal', event => {
    var segments = document.location.pathname.split('/');
    var title = getUrlTitle(segments.slice(segments[2] === 'p' ? 3 : 2)) + ' - [modal] ' + event.detail.name;
    this.trackPageView({ name: title, refUri: document.referrer, uri: document.location });
  });

  window.addEventListener('ai-customevent', event => {
    appInsights.trackEvent({ name: event.detail.name, properties: event.detail.properties });
  });

  window.addEventListener('apperror', event => {
    appInsights.trackException({ error: event.detail.error, properties: { appName: event.detail.appName } });
  });

  window.addEventListener('popstate', function(event) {
    appInsights.trackCurrentPageView();
  });

  appInsights.trackCurrentPageView = function() {
    var segments = document.location.pathname.split('/');
    var title = getUrlTitle(segments.slice(segments[2] === 'p' ? 3 : 2));
    this.trackPageView({ name: title, refUri: document.referrer, uri: document.location });
  };

  return appInsights;
}

function isNeedFilterTelemetryItem(target, filterStrings) {
  for (var i = 0; i < filterStrings.length; i++) {
    if (target.includes(filterStrings[i])) {
      return true;
    }
  }
  return false;
}

export { initAppInsights };
